import { render, staticRenderFns } from "./AppActionTiles.vue?vue&type=template&id=3922bfaa&scoped=true"
import script from "./AppActionTiles.vue?vue&type=script&lang=js"
export * from "./AppActionTiles.vue?vue&type=script&lang=js"
import style0 from "./AppActionTiles.vue?vue&type=style&index=0&id=3922bfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922bfaa",
  null
  
)

export default component.exports